/*
 * Module for the Checks (Benefit) job criteria page
 */
rs.module("content/jobs/criteria/checksbenefit",

    ["common/select-helper", "common/visibility", "controls/components/event-banner"],

    function (selectHelper, visibility, eventBanner) {

        // Initialize the page
        function initialize(jsSelectors, modes, outputTypes, rangeTypes, defaultPrinter, defaultStartingCheckNumber, backendUrls) {
            var criteria = $.js(jsSelectors.criteria);

            var payrollTypeLoadingSpinner = criteria.js(jsSelectors.payrollTypeLoadingSpinner);
            var modeLoadingSpinner = criteria.js(jsSelectors.modeLoadingSpinner);
            var outputTypeLoadingSpinner = criteria.js(jsSelectors.outputTypeLoadingSpinner);
            var monthLoadingSpinner = criteria.js(jsSelectors.monthLoadingSpinner);
            var yearLoadingSpinner = criteria.js(jsSelectors.yearLoadingSpinner);

            var payrollTypeSelect = criteria.js(jsSelectors.payrollTypeSelect);
            var modeRadioContainer = criteria.js(jsSelectors.modeRadioContainer);
            var outputTypeSelect = criteria.js(jsSelectors.outputTypeSelect);
            var calendarContainer = criteria.js(jsSelectors.calendarContainer);
            var monthSelect = criteria.js(jsSelectors.monthSelect);
            var yearSelect = criteria.js(jsSelectors.yearSelect);
            var gridContent = criteria.js(jsSelectors.gridContent);
            var emptyGridContent = criteria.js(jsSelectors.emptyGridContent);
            var startingCheckNumberInput = criteria.js(jsSelectors.startingCheckNumberInput);
            var useExistingCheckNumberContainer = criteria.js(jsSelectors.useExistingCheckNumberContainer);
            var useExistingCheckNumberCheckBox = criteria.js(jsSelectors.useExistingCheckNumberCheckBox);
            var rangeContainer = criteria.js(jsSelectors.rangeContainer);
            var rangeTypeRadioContainer = criteria.js(jsSelectors.rangeTypeRadioContainer);
            var checkNumberRangeContainer = criteria.js(jsSelectors.checkNumberRangeContainer);
            var printerSelect = criteria.js(jsSelectors.printerSelect);
            var producePositivePayFileContainer = criteria.js(jsSelectors.producePositivePayFileContainer);

            // Get Select Helpers for selects where we're updating options and properties
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            // Register payrollTypeSelect changed event
            payrollTypeSelect.change(() => updateContentDisplay(jsSelectors.payrollTypeSelect));

            // Register click event for mode radio buttons 
            modeRadioContainer.find("input").on("click", () => updateContentDisplay(jsSelectors.modeRadioContainer));

            // Register outputTypeSelect changed event
            outputTypeSelect.change(() => updateContentDisplay(jsSelectors.outputTypeSelect));

            // Register monthSelect changed event
            monthSelect.change(() => updateContentDisplay(jsSelectors.monthSelect));

            // Register yearSelect changed event
            yearSelect.change(() => updateContentDisplay(jsSelectors.yearSelect));

            // Register useExistingCheckNumberCheckBox changed event
            useExistingCheckNumberCheckBox.change(function () {
                enableDisableStartingCheckNumber();
            });

            // Register click event for range type radio buttons 
            rangeTypeRadioContainer.find("input").on("click", () => updateRangeDisplay());

            // Handle dynamic display of content
            function updateContentDisplay(jsSelector) {

                // Clear business errors
                eventBanner.removeAllMessages();

                // get selected payroll type
                var selectedPayrollType = payrollTypeSelect.val();

                // get selected mode
                var selectedMode = modeRadioContainer.find("input:checked").val();

                // get selected output type
                var selectedOutputType = outputTypeSelect.val();

                // determine what has changed so we can react accordingly
                if (jsSelector == jsSelectors.payrollTypeSelect) {
                    payrollTypeLoadingSpinner.show();
                }
                else if (jsSelector == jsSelectors.modeRadioContainer) {
                    modeLoadingSpinner.show();

                    // show/hide month and year drop downs based on selected mode
                    visibility.setVisible(calendarContainer, selectedMode == modes.recreate);

                }
                else if (jsSelector == jsSelectors.outputTypeSelect) {
                    outputTypeLoadingSpinner.show();
                }
                else if (jsSelector == jsSelectors.monthSelect) {
                    monthLoadingSpinner.show();
                }
                else if (jsSelector == jsSelectors.yearSelect) {
                    yearLoadingSpinner.show();
                }

                // display appropriate partial view (grid) based on selected mode 
                if (selectedMode == modes.recreate) {

                    // get selected month and year
                    var month = monthSelect.val();
                    var year = yearSelect.val();

                    _updateGridContentFrom(
                        backendUrls.getGridPartialView,
                        {
                            payrollType: selectedPayrollType,
                            mode: selectedMode,
                            outputType: selectedOutputType,
                            month: month,
                            year: year
                        });
                }
                else {
                    _updateGridContentFrom(
                        backendUrls.getGridPartialView,
                        {
                            payrollType: selectedPayrollType,
                            mode: selectedMode,
                            outputType: selectedOutputType
                        });
                }

                // enable/disable the remaining child controls beneath the partial view (grid)
                updateChildControls(selectedMode, selectedOutputType);
            }

            // Update grid content (partial views) from a url with parameters 
            function _updateGridContentFrom(url, parameters) {

                $.get(url, parameters)
                    .done(function (html) {
                        gridContent.html(html);

                        visibility.hide(emptyGridContent);
                        visibility.show(gridContent);

                        // Update the starting check number.
                        startingCheckNumberInput.val(gridContent.js(jsSelectors.defaultCheckNumber).val());
                    })
                    .fail(function () {
                        visibility.hide(gridContent);
                        visibility.show(emptyGridContent);

                        startingCheckNumberInput.val('');
                    })
                    .always(function () {
                        payrollTypeLoadingSpinner.hide();
                        modeLoadingSpinner.hide();
                        outputTypeLoadingSpinner.hide();
                        monthLoadingSpinner.hide();
                        yearLoadingSpinner.hide();
                    });                         
            }

            // enable/disable the remaining child controls, beneath the partial view (grid), based on combos of payroll type, mode and output type
            function updateChildControls(selectedMode, selectedOutputType) {

                visibility.setVisible(useExistingCheckNumberContainer, selectedMode == modes.recreate);
                visibility.setVisible(rangeContainer, selectedMode == modes.recreate);
                visibility.setVisible(producePositivePayFileContainer, selectedMode != modes.recreate);

                if (selectedMode == modes.recreate) {
                    updateRangeDisplay();
                }

                if (selectedOutputType != outputTypes.print) {
                    printerSelectHelper.setDisabled(true);
                    printerSelectHelper.setValue(defaultPrinter);          
                }
                else {
                    printerSelectHelper.setDisabled(false);
                }
            }

            // Handle enabling/disabling of useExistingCheckNumberCheckBox
            function enableDisableStartingCheckNumber() {

                if (useExistingCheckNumberCheckBox.is(":checked")) {
                    startingCheckNumberInput.prop("disabled", true).clearErrors().val(defaultStartingCheckNumber);
                }
                else {
                    startingCheckNumberInput.prop("disabled", false);
                }
            }

            // Handle dynamic display of range fields
            function updateRangeDisplay() {

                // get selected range type
                var selectedRangeType = rangeTypeRadioContainer.find("input:checked").val();

                visibility.setVisible(checkNumberRangeContainer, selectedRangeType == rangeTypes.checkNumber);
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);